export default function InvoiceSummaryIcon({
  width = 20,
  height = 21,
  color = "#8E8C8F",
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 5.5H6.66663"
        stroke={color}
        stroke-width="1.7"
        stroke-linejoin="round"
      />
      <path
        d="M9.16663 8.83331H6.66663"
        stroke={color}
        stroke-width="1.7"
        stroke-linejoin="round"
      />
      <path
        d="M12.0834 8.72915C11.393 8.72915 10.8334 9.21881 10.8334 9.8229C10.8334 10.427 11.393 10.9166 12.0834 10.9166C12.7737 10.9166 13.3334 11.4063 13.3334 12.0104C13.3334 12.6145 12.7737 13.1041 12.0834 13.1041M12.0834 8.72915C12.6276 8.72915 13.0906 9.03348 13.2622 9.45831M12.0834 8.72915V7.58331M12.0834 13.1041C11.5391 13.1041 11.0761 12.7998 10.9045 12.375M12.0834 13.1041V14.25"
        stroke={color}
        stroke-width="1.7"
        stroke-linejoin="round"
      />
      <path
        d="M17.0911 18.3073V2.20217C17.0911 2.15609 16.6297 2.16694 16.5837 2.16694H2.97502C2.92899 2.16694 2.92293 2.27856 2.92293 2.32464V18.3883C2.92293 18.4507 2.91374 18.4399 2.96919 18.4115L6.24512 16.7611L9.969 18.822C9.99408 18.836 10.0246 18.836 10.0497 18.8221L13.7408 16.7529L17.0042 18.4109C17.0596 18.4391 17.0911 18.3696 17.0911 18.3073Z"
        stroke={color}
        stroke-width="1.7"
      />
    </svg>
  );
}
